import { __decorate, __metadata } from "tslib";
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { UserManagementService } from '../+state/user-management.service';
import { Router } from '@angular/router';
let AccountResolverService = class AccountResolverService {
    constructor(_userManagementService, _router) {
        this._userManagementService = _userManagementService;
        this._router = _router;
    }
    resolve(route, state) {
        return this._userManagementService
            .getAccount(+route.parent.parent.params['id'] || +route.parent.params['id'])
            .pipe(catchError((err) => {
            this._router.navigate(['/d/user-operations/all-users']);
            return of(err);
        }));
    }
};
AccountResolverService.ctorParameters = () => [
    { type: UserManagementService },
    { type: Router }
];
AccountResolverService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [UserManagementService, Router])
], AccountResolverService);
export { AccountResolverService };
